var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8085 10.533L21.6942 10.663C21.5512 10.8213 21.3491 10.9202 21.131 10.9385C20.9128 10.9568 20.6957 10.8931 20.526 10.761L11.4999 3.53278C11.36 3.42039 11.1829 3.35876 11 3.35876C10.8171 3.35876 10.6401 3.42039 10.5001 3.53278L1.47395 10.761C1.30421 10.8931 1.08716 10.9568 0.868962 10.9385C0.650769 10.9202 0.448668 10.8214 0.305668 10.663L0.191371 10.533C0.0516335 10.3715 -0.0159598 10.1641 0.00319088 9.95547C0.0223416 9.74685 0.126699 9.55379 0.293722 9.41799L10.8802 0.940796C10.9136 0.913464 10.9561 0.898438 11.0001 0.898438C11.044 0.898438 11.0865 0.913464 11.1199 0.940796L21.7064 9.41799C21.8732 9.55392 21.9774 9.74697 21.9965 9.95552C22.0156 10.1641 21.9481 10.3715 21.8085 10.533ZM18.4651 19.5246V10.5281L10.9998 4.55042L3.91994 10.2198V19.5246C3.92004 19.584 3.94479 19.6408 3.98875 19.6828C4.03272 19.7247 4.09231 19.7483 4.15446 19.7483H7.71928V14.0621C7.71951 13.8427 7.81088 13.6325 7.97335 13.4774C8.13582 13.3223 8.35611 13.2351 8.58587 13.2349H13.7991C14.0289 13.2351 14.2492 13.3224 14.4117 13.4774C14.5742 13.6325 14.6656 13.8427 14.666 14.0621V19.7483H18.2306C18.2927 19.7483 18.3523 19.7247 18.3963 19.6828C18.4403 19.6408 18.465 19.584 18.4651 19.5246ZM13.528 19.7483H8.85731V14.3211H13.528V19.7483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon1);
export default __webpack_public_path__ + "static/media/banner_icon1.0fc7dd30af82fa05ebe701fba48b1d54.svg";
export { ForwardRef as ReactComponent };